module.exports = "<app-navbar></app-navbar>\n<app-sidebar></app-sidebar>\n<footer class=\"app-footer\">\n</footer>"


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/layouts/full-layout.component.html
// module id = ../../../../../src/app/layouts/full-layout.component.html
// module chunks = main